import dayjs from 'dayjs';

import type { CoinBack } from './types';

const MOCK_WIDGET_IMAGE_URL =
  'https://static-assets.dev.crowncoinscasino.com/development/assets/coin-back/widget-image-1718882317990.png';
const MOCK_BOOSTER_WIDGET_IMAGE_URL =
  'https://static.dev.crowncoinscasino.com/development/assets/coin-back/default-booster-widget-image-1723559496226.png';

export const coinBackMock: { data: { coinBackData: CoinBack } } = {
  data: {
    coinBackData: {
      collectableGcAmount: 0,
      collectableScAmount: 0,
      lockedGcAmount: 0,
      lockedScAmount: 0,
      showWidget: true,
      showTimer: true,
      endDate: dayjs().add(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      loyaltyTierMultiplier: 0.01,
      houseEdgeMultiplier: 0.01,
      widgetImageUrl: MOCK_WIDGET_IMAGE_URL,
      defaultBoosterWidgetImageUrl: MOCK_BOOSTER_WIDGET_IMAGE_URL,
      acknowledgedStart: false,
      tutorialBonusGc: 0,
      tutorialBonusSc: 0,
    },
  },
};
